import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { TmsWebBaseEditService } from '../base';
import { StockItem, StockItemForRemeasure } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class StockItemForRemeasureService extends TmsWebBaseEditService<StockItem, StockItemForRemeasure> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('StockItemForRemeasure', $localize`Stock Item for Remeasure`);
  }
}
